/**
 * 通用的服务器数据转换逻辑
 * @author haoru
 */

import { IDoctorInfo } from '@/schemas/doctor';

const addServiceTypeMapForDoctor = (
  doctor: Omit<IDoctorInfo, 'serviceTypeMap'>
) => {
  if (doctor && doctor.serviceTypeList) {
    const serviceTypeMap = {};
    for (const s of doctor.serviceTypeList) {
      serviceTypeMap[s.type] = s;
    }
    Object.assign(doctor, { serviceTypeMap });
  }
  return doctor as IDoctorInfo;
};

const getPriceInServiceTypeList = (
  doctor: IDoctorInfo,
  productType: number
) => {
  return Number(
    doctor?.serviceTypeList?.find((s) => s.type === productType)?.serviceFee ||
      doctor?.generalFee
  );
};

export default { addServiceTypeMapForDoctor, getPriceInServiceTypeList };
